/**
 *  The Salesforce field names used to persist responses for the Admin quick start.
 */
export enum FieldName {
  // Integration fields
  Email_Domains = "Email_Domains__c",
  Primary_Integration = "Primary_Integration__c",
  Primary_Integration_Other = "Primary_Integration_Other__c",
  Portal_Used = "Portal_Used__c",
  Portal_Used_Other = "Portal_Used_Other__c",
  LMS = "LMS__c",
  LMS_Other = "LMS_Other__c",
  NWEA_Intent = "NWEA_Intent__c",
  Access_Newsela_Date = "Access_Newsela_Date__c",

  // Key Team Members fields
  Key_Team_Member_Notes = "Key_Team_Member_Notes__c",

  // Professional Learning fields
  Confidence_of_PL_in_First_60_Days = "Confidence_of_PL_in_First_60_Days__c",
  Professional_Learning_Notes = "Professional_Learning_Notes__c",

  // Communication fields
  //  NOTE: These two fields are misspelled in Salesforce so "_Teache_" is accurate.
  Communication_Channel_for_Teacher = "Communication_Channel_for_Teache__c",
  Communication_Channel_for_Teacher_Other = "Communication_Channel_for_Teache_Other__c",

  // Instructional Best Practice fields
  Usage_Level_Confidence = "Usage_Level_Confidence__c",
  Usage_Level_Notes = "Usage_Level_Notes__c",
  Time_Commitment_Confidence = "Time_Commitment_Confidence__c",
  Time_Commitment_Notes = "Time_Commitment_Notes__c",
  Usage_Level_Practices = "Usage_Level_Practices__c",

  // Measuring Success fields
  Priority_Group_1_Ending_Grade = "Priority_Group_1_Ending_Grade__c",
  Priority_Group_1_Starting_Grade = "Priority_Group_1_Starting_Grade__c",
  Priority_Group_1_Subject_Area = "Priority_Group_1_Subject_Area__c",
  Priority_Group_2_Ending_Grade = "Priority_Group_2_Ending_Grade__c",
  Priority_Group_2_Starting_Grade = "Priority_Group_2_Starting_Grade__c",
  Priority_Group_2_Subject_Area = "Priority_Group_2_Subject_Area__c",
  Priority_Group_3_Ending_Grade = "Priority_Group_3_Ending_Grade__c",
  Priority_Group_3_Starting_Grade = "Priority_Group_3_Starting_Grade__c",
  Priority_Group_3_Subject_Area = "Priority_Group_3_Subject_Area__c",
  Reporting_Monitoring_Confidence = "Reporting_Monitoring_Confidence__c",
  Reporting_Monitoring_Notes = "Reporting_Monitoring_Notes__c",
}

export const UnrequiredFieldNames = Object.values([
  FieldName.Primary_Integration_Other,
  FieldName.Portal_Used_Other,
  FieldName.LMS_Other,
  FieldName.Professional_Learning_Notes,
  FieldName.Communication_Channel_for_Teacher_Other,
  FieldName.Usage_Level_Notes,
  FieldName.Time_Commitment_Notes,
  FieldName.Reporting_Monitoring_Notes,
  FieldName.Priority_Group_2_Ending_Grade,
  FieldName.Priority_Group_2_Starting_Grade,
  FieldName.Priority_Group_2_Subject_Area,
  FieldName.Priority_Group_3_Ending_Grade,
  FieldName.Priority_Group_3_Starting_Grade,
  FieldName.Priority_Group_3_Subject_Area,
]);
